import React, { Component,Fragment } from 'react';
import { Tabs, TabList, TabPanel, Tab } from 'react-tabs';
import { Settings as SettingsIcon, MessageCircle } from 'react-feather';
import { WhatsappProviderSettings } from './whatsapp-provider-settings';
import Breadcrumb from '../common/breadcrumb';
import CKEditors from "react-ckeditor-component";
import MyDropzone from '../common/dropzone'
import AuthService from "../services/auth.service";
import ApiService from "../services/api.service";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import TextArea from "react-validation/build/textarea";
import CheckButton from "react-validation/build/button";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select';
import { Link } from 'react-router-dom';
import Modal from 'react-responsive-modal';
import Swal from 'sweetalert2';

// image import
import primera_imagen from '../../assets/images/example/primera_imagen.png'
import segunda_imagen from '../../assets/images/example/segunda_imagen.png'
import logo_producto from '../../assets/images/example/logo_producto.png'
import primera_caracteristica from '../../assets/images/example/primera_caracteristica.png'
import segunda_caracteristica from '../../assets/images/example/segunda_caracteristica.png'
import tercera_caracteristica from '../../assets/images/example/tercera_caracteristica.png'

const required = value => {
    if (!value) {
      return (
        <div className="alert alert-danger" role="alert">
          Este campo es obligatorio!
        </div>
      );
    }
  };

const items = [];

export class VerSettings extends Component {
    selectRef = null;
    constructor(props) {
        super(props);
        this.handleUpdate = this.handleUpdate.bind(this);
        this.onChangeMontoMinimo = this.onChangeMontoMinimo.bind(this);
        this.onChangeMontoSinDelivery = this.onChangeMontoSinDelivery.bind(this);
        this.onChangeIntentosLogin = this.onChangeIntentosLogin.bind(this);
        this.onChangeNewPercentCashback = this.onChangeNewPercentCashback.bind(this);
        this.onChangePhoneNumber = this.onChangePhoneNumber.bind(this);
        this.onChangePhoneNumberOperations = this.onChangePhoneNumberOperations.bind(this);
        this.onChangeWhatsappDailyLimit = this.onChangeWhatsappDailyLimit.bind(this);

        this.state = {
            minimum_amount: 0,
            maximum_amount_no_delivery : 0,
            maximum_login_attemps : 0,
            is_checked : false,
            percent_cashback : 0,
            phonenumber: '',
            phonenumber_operations: '',
            notify_new_order_operations: false,
            notify_new_order_phonenumber: false,
            notify_principal_payment: false,
            notify_principal_new_address: false,
            notify_customer_new_order: false,
            notify_customer_payment: false,
            notify_customer_new_address: false,
            notify_customer_profile_update: false,
            notify_debt_reminder_auto: false,
            notify_security_reminder: false,
            notify_debt_charge_manual: false,
            notify_marketing_campaigns: false,
            whatsapp_daily_limit: 250,
        }
    }

    componentWillMount() {
        this.getdataSettings();
    }

    onChangeNewPercentCashback(e) {
      this.setState({
        percent_cashback: e.target.value
      });
    }

    onChangeMontoMinimo(e) {
        this.setState({
            minimum_amount: e.target.value
        });
      }

    onChangeMontoSinDelivery(e) {
        this.setState({
            maximum_amount_no_delivery: e.target.value
        });
      }

    onChangeIntentosLogin(e) {
        this.setState({
          maximum_login_attemps: e.target.value
        });
      }
    onChangePhoneNumber(e) {
        this.setState({
          phonenumber: e.target.value
        });
      }

    onChangePhoneNumberOperations(e) {
        this.setState({
          phonenumber_operations: e.target.value
        });
      }

    onChangeWhatsappDailyLimit(e) {
        this.setState({
          whatsapp_daily_limit: e.target.value
        });
      }
    
    
 

    getdataSettings(){
        var user = AuthService.getCurrentUser();
        ApiService.getSettings(user.token).then(
            (res) => {
                if(res && res.status == 'success'){
                    let data = res.data;
                    for (let i = 0; i < data.length; i++) {
                      const element = data[i];
                      let option = element.option_name;
                      let value = element.option_value;
                      if(option == 'minimum_amount')
                      {
                        this.setState({
                          minimum_amount: value
                        });
                      }

                      if(option == 'maximum_amount_no_delivery')
                      {
                        this.setState({
                          maximum_amount_no_delivery: value
                        });
                      }

                      if(option == 'maximum_login_attemps')
                      {
                        this.setState({
                          maximum_login_attemps: value
                        });
                      }

                      if(option == 'percent_cashback')
                      {
                        this.setState({
                          percent_cashback: value
                        });
                      }

                      if(option == 'is_open')
                      {
                        if(value == 'SI')
                        {
                          this.setState(
                            { 
                              is_checked: true
                            },
                            () => {});
                        }
                      }

                      if(option == 'phonenumber')
                        {
                          this.setState({
                            phonenumber: value
                          });
                        }

                      if(option == 'phonenumber_operations')
                        {
                          this.setState({
                            phonenumber_operations: value
                          });
                        }

                      if(option == 'notify_new_order_operations')
                        {
                          this.setState({ notify_new_order_operations: value == 'SI' });
                        }

                      if(option == 'notify_new_order_phonenumber')
                        {
                          this.setState({ notify_new_order_phonenumber: value == 'SI' });
                        }

                      if(option == 'notify_principal_payment')
                        { this.setState({ notify_principal_payment: value == 'SI' }); }

                      if(option == 'notify_principal_new_address')
                        { this.setState({ notify_principal_new_address: value == 'SI' }); }

                      if(option == 'notify_customer_new_order')
                        { this.setState({ notify_customer_new_order: value == 'SI' }); }

                      if(option == 'notify_customer_payment')
                        { this.setState({ notify_customer_payment: value == 'SI' }); }

                      if(option == 'notify_customer_new_address')
                        { this.setState({ notify_customer_new_address: value == 'SI' }); }

                      if(option == 'notify_customer_profile_update')
                        { this.setState({ notify_customer_profile_update: value == 'SI' }); }

                      if(option == 'notify_debt_reminder_auto')
                        { this.setState({ notify_debt_reminder_auto: value == 'SI' }); }

                      if(option == 'notify_security_reminder')
                        { this.setState({ notify_security_reminder: value == 'SI' }); }

                      if(option == 'notify_debt_charge_manual')
                        { this.setState({ notify_debt_charge_manual: value == 'SI' }); }

                      if(option == 'notify_marketing_campaigns')
                        { this.setState({ notify_marketing_campaigns: value == 'SI' }); }

                      if(option == 'whatsapp_daily_limit')
                        { this.setState({ whatsapp_daily_limit: value }); }
                    }
                }
            },
            error => {
              const resMessage =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();
            }
          );
    }




      handleUpdate(e) {
        e.preventDefault();
    
        this.form.validateAll();

        if (this.checkBtn.context._errors.length === 0) {
            this.setState({
                message: "",
                loading: true
              });
            var user = AuthService.getCurrentUser();
            let data_user = []

            let data = {}

            data = {
              'name': 'minimum_amount',
              'value': this.state.minimum_amount,
            }

            data_user.push(data)

            data = {
              'name': 'maximum_amount_no_delivery',
              'value': this.state.maximum_amount_no_delivery,
            }

            data_user.push(data)

            data = {
              'name': 'maximum_login_attemps',
              'value': this.state.maximum_login_attemps,
            }

            data_user.push(data)

            data = {
              'name': 'percent_cashback',
              'value': this.state.percent_cashback,
            }

            data_user.push(data)

            var is_open = 'SI'
            if(this.state.is_checked == false){
              is_open = 'NO';
            }

            data = {
              'name': 'is_open',
              'value': is_open,
            }

            data_user.push(data)

            data = {
              'name': 'phonenumber',
              'value': this.state.phonenumber,
            }

            data_user.push(data)

            data = {
              'name': 'phonenumber_operations',
              'value': this.state.phonenumber_operations,
            }

            data_user.push(data)

            data = {
              'name': 'notify_new_order_operations',
              'value': this.state.notify_new_order_operations ? 'SI' : 'NO',
            }

            data_user.push(data)

            data = {
              'name': 'notify_new_order_phonenumber',
              'value': this.state.notify_new_order_phonenumber ? 'SI' : 'NO',
            }

            data_user.push(data)

            data_user.push({ 'name': 'notify_principal_payment',        'value': this.state.notify_principal_payment        ? 'SI' : 'NO' })
            data_user.push({ 'name': 'notify_principal_new_address',    'value': this.state.notify_principal_new_address    ? 'SI' : 'NO' })

            data_user.push({ 'name': 'notify_customer_new_order',      'value': this.state.notify_customer_new_order      ? 'SI' : 'NO' })
            data_user.push({ 'name': 'notify_customer_payment',        'value': this.state.notify_customer_payment        ? 'SI' : 'NO' })
            data_user.push({ 'name': 'notify_customer_new_address',    'value': this.state.notify_customer_new_address    ? 'SI' : 'NO' })
            data_user.push({ 'name': 'notify_customer_profile_update', 'value': this.state.notify_customer_profile_update ? 'SI' : 'NO' })

            data_user.push({ 'name': 'notify_debt_reminder_auto',   'value': this.state.notify_debt_reminder_auto   ? 'SI' : 'NO' })
            data_user.push({ 'name': 'notify_security_reminder',    'value': this.state.notify_security_reminder    ? 'SI' : 'NO' })
            data_user.push({ 'name': 'notify_debt_charge_manual',   'value': this.state.notify_debt_charge_manual   ? 'SI' : 'NO' })
            data_user.push({ 'name': 'notify_marketing_campaigns',  'value': this.state.notify_marketing_campaigns  ? 'SI' : 'NO' })

            data_user.push({ 'name': 'whatsapp_daily_limit',  'value': this.state.whatsapp_daily_limit })

            let json_data = {}
            json_data['data'] = data_user;


            ApiService.updateSettings(user.token,json_data).then(
            (res) => {
                if(res){
                    if(res && res.status == 'success'){
                      Swal.fire("Hecho!", 'Configuración guardada.', "success");
                      this.setState({
                        loading: false
                      });
                        //window.location.reload();
                    }else{
                        Swal.fire("Error", res.message, "error");
                        this.setState({
                            message: "",
                            loading: false
                          });
                        return true;
                    }
                }
            },
            error => {
              const resMessage =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();
    
              this.setState({
                loading: false,
                message: resMessage
              });
            }
          );
        } else {
          this.setState({
            loading: false
          });
        }
      }


    render() {
        const { selectedOption, selectedSubCategOption, selectedOptionGramaje1, selectedOptionGramaje2, selectedOptionGramaje3, open_example } = this.state;
        const { selectedTemplateOption } = this.state;

        return (
            <Fragment>
                <Breadcrumb title="Configuración" parent="Digital" />
                <div className="container-fluid">
                <Tabs>
                    <TabList className="nav nav-tabs tab-coupon">
                        <Tab className="nav-link"><SettingsIcon className="mr-2" size={16} />General</Tab>
                        <Tab className="nav-link"><MessageCircle className="mr-2" size={16} />WhatsApp — Proveedor</Tab>
                    </TabList>

                    <TabPanel>
                    <Form
                        onSubmit={this.handleUpdate}
                        encType="multipart/form-data"
                        method="POST"
                        ref={c => {this.form = c;
                    }}>
                    <div className="row product-adding">
                        <div className="col-xl-6">
                            <div className="card">
                                <div className="card-header">
                                    <h5>General</h5>
                                </div>
                                <div className="card-body">
                                    <div className="digital-add needs-validation">
                                        <div className="form-group">
                                            <label className="col-form-label pt-0"><span>*</span> Monto Mínimo de Compra</label>
                                            <Input 
                                                name="name" 
                                                value={this.state.minimum_amount} 
                                                type="text" 
                                                className="form-control" 
                                                onChange={this.onChangeMontoMinimo}
                                                validations={[required]}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label className="col-form-label pt-0"><span>*</span> Cantidad de intentos de login</label>
                                            <Input 
                                                name="name" 
                                                value={this.state.maximum_login_attemps} 
                                                type="text" 
                                                className="form-control" 
                                                onChange={this.onChangeIntentosLogin}
                                                validations={[required]}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label className="col-form-label pt-0"><span>*</span> Número de celular - Principal</label>
                                            <Input
                                                name="name"
                                                value={this.state.phonenumber}
                                                type="text"
                                                className="form-control"
                                                onChange={this.onChangePhoneNumber}
                                                validations={[required]}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label className="col-form-label pt-0"><span>*</span> Número de celular - Operaciones</label>
                                            <Input
                                                name="phonenumber_operations"
                                                value={this.state.phonenumber_operations}
                                                type="text"
                                                className="form-control"
                                                onChange={this.onChangePhoneNumberOperations}
                                                validations={[required]}
                                            />
                                        </div>
                                    </div>  
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-6">
                            <div className="card">
                                <div className="card-header">
                                    <h5></h5>
                                </div>
                                <div className="card-body">
                                    <br/>
                                    <div className="digital-add needs-validation prod-block-right">

                                        <div className="form-group">
                                            <label className="col-form-label pt-0"><span>*</span> Monto Sin Delivery</label>
                                            <Input 
                                                name="name" 
                                                value={this.state.maximum_amount_no_delivery} 
                                                type="text" 
                                                className="form-control" 
                                                onChange={this.onChangeMontoSinDelivery}
                                                validations={[required]}
                                            />
                                        </div>

                                        <div className="form-group">
                                            <label className="col-form-label pt-0"><span>*</span> % de cashback</label>
                                            <Input 
                                                name="name" 
                                                value={this.state.percent_cashback} 
                                                type="text" 
                                                className="form-control" 
                                                onChange={this.onChangeNewPercentCashback}
                                                validations={[required]}
                                            />
                                        </div>

                                        <div className="form-group" style={{marginTop: '3rem'}}>
                                          <label className="d-block">
                                              <input
                                              id="chk_open"
                                              className="checkbox_animated"
                                              type="checkbox"
                                              onChange={checked => this.setState({ is_checked: !this.state.is_checked })} checked={this.state.is_checked}
                                              />
                                              ¿Hay Atención?
                                          </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Cards: Operaciones + Principal + WewithBot — quién recibe qué, separado por destinatario */}
                    <div className="row product-adding">
                        <div className="col-xl-4">
                            <div className="card h-100">
                                <div className="card-header">
                                    <h5>Notificaciones — Operaciones</h5>
                                    <span className="f-light">Al número de "Operaciones" configurado arriba.</span>
                                </div>
                                <div className="card-body">
                                    <div className="digital-add needs-validation">
                                        <div className="form-group">
                                            <label className="d-block">
                                                <input
                                                    className="checkbox_animated"
                                                    type="checkbox"
                                                    onChange={() => this.setState({ notify_new_order_operations: !this.state.notify_new_order_operations })}
                                                    checked={this.state.notify_new_order_operations}
                                                />
                                                Nuevo pedido
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4">
                            <div className="card h-100">
                                <div className="card-header">
                                    <h5>Notificaciones — Principal</h5>
                                    <span className="f-light">Al número "Principal" configurado arriba.</span>
                                </div>
                                <div className="card-body">
                                    <div className="digital-add needs-validation">
                                        <div className="form-group">
                                            <label className="d-block">
                                                <input
                                                    className="checkbox_animated"
                                                    type="checkbox"
                                                    onChange={() => this.setState({ notify_new_order_phonenumber: !this.state.notify_new_order_phonenumber })}
                                                    checked={this.state.notify_new_order_phonenumber}
                                                />
                                                Nuevo pedido
                                            </label>
                                        </div>
                                        <div className="form-group">
                                            <label className="d-block">
                                                <input
                                                    className="checkbox_animated"
                                                    type="checkbox"
                                                    onChange={() => this.setState({ notify_principal_payment: !this.state.notify_principal_payment })}
                                                    checked={this.state.notify_principal_payment}
                                                />
                                                Pago registrado
                                            </label>
                                        </div>
                                        <div className="form-group">
                                            <label className="d-block">
                                                <input
                                                    className="checkbox_animated"
                                                    type="checkbox"
                                                    onChange={() => this.setState({ notify_principal_new_address: !this.state.notify_principal_new_address })}
                                                    checked={this.state.notify_principal_new_address}
                                                />
                                                Nueva dirección agregada
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4">
                            <div className="card h-100">
                                <div className="card-header">
                                    <h5>Notificaciones — Cliente (WewithBot 🤖)</h5>
                                    <span className="f-light">Al celular del cliente que hizo la acción.</span>
                                </div>
                                <div className="card-body">
                                    <div className="digital-add needs-validation">
                                        <div className="form-group">
                                            <label className="d-block">
                                                <input
                                                    className="checkbox_animated"
                                                    type="checkbox"
                                                    onChange={() => this.setState({ notify_customer_new_order: !this.state.notify_customer_new_order })}
                                                    checked={this.state.notify_customer_new_order}
                                                />
                                                Nuevo pedido
                                            </label>
                                        </div>
                                        <div className="form-group">
                                            <label className="d-block">
                                                <input
                                                    className="checkbox_animated"
                                                    type="checkbox"
                                                    onChange={() => this.setState({ notify_customer_payment: !this.state.notify_customer_payment })}
                                                    checked={this.state.notify_customer_payment}
                                                />
                                                Pago registrado
                                            </label>
                                        </div>
                                        <div className="form-group">
                                            <label className="d-block">
                                                <input
                                                    className="checkbox_animated"
                                                    type="checkbox"
                                                    onChange={() => this.setState({ notify_customer_new_address: !this.state.notify_customer_new_address })}
                                                    checked={this.state.notify_customer_new_address}
                                                />
                                                Nueva dirección agregada
                                            </label>
                                        </div>
                                        <div className="form-group">
                                            <label className="d-block">
                                                <input
                                                    className="checkbox_animated"
                                                    type="checkbox"
                                                    onChange={() => this.setState({ notify_customer_profile_update: !this.state.notify_customer_profile_update })}
                                                    checked={this.state.notify_customer_profile_update}
                                                />
                                                Perfil actualizado
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Cards: Límite de envío + Recordatorios/cobranza + Marketing — separados por propósito */}
                    <div className="row product-adding">
                        <div className="col-xl-4">
                            <div className="card h-100">
                                <div className="card-header">
                                    <h5>Límite de envío</h5>
                                </div>
                                <div className="card-body">
                                    <div className="digital-add needs-validation">
                                        <div className="form-group">
                                            <label className="col-form-label pt-0"><span>*</span> Máximo de WhatsApp por día (no incluye OTP)</label>
                                            <Input
                                                name="name"
                                                value={this.state.whatsapp_daily_limit}
                                                type="text"
                                                className="form-control"
                                                onChange={this.onChangeWhatsappDailyLimit}
                                                validations={[required]}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4">
                            <div className="card h-100">
                                <div className="card-header">
                                    <h5>Recordatorios y cobranza</h5>
                                </div>
                                <div className="card-body">
                                    <div className="digital-add needs-validation">
                                        <div className="form-group">
                                            <label className="d-block">
                                                <input
                                                    className="checkbox_animated"
                                                    type="checkbox"
                                                    onChange={() => this.setState({ notify_debt_reminder_auto: !this.state.notify_debt_reminder_auto })}
                                                    checked={this.state.notify_debt_reminder_auto}
                                                />
                                                Recordatorio de deuda automático (diario)
                                            </label>
                                        </div>
                                        <div className="form-group">
                                            <label className="d-block">
                                                <input
                                                    className="checkbox_animated"
                                                    type="checkbox"
                                                    onChange={() => this.setState({ notify_security_reminder: !this.state.notify_security_reminder })}
                                                    checked={this.state.notify_security_reminder}
                                                />
                                                Recordatorio semanal de seguridad
                                            </label>
                                        </div>
                                        <div className="form-group">
                                            <label className="d-block">
                                                <input
                                                    className="checkbox_animated"
                                                    type="checkbox"
                                                    onChange={() => this.setState({ notify_debt_charge_manual: !this.state.notify_debt_charge_manual })}
                                                    checked={this.state.notify_debt_charge_manual}
                                                />
                                                Cobro masivo manual
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4">
                            <div className="card h-100">
                                <div className="card-header">
                                    <h5>Marketing</h5>
                                </div>
                                <div className="card-body">
                                    <div className="digital-add needs-validation">
                                        <div className="form-group">
                                            <label className="d-block">
                                                <input
                                                    className="checkbox_animated"
                                                    type="checkbox"
                                                    onChange={() => this.setState({ notify_marketing_campaigns: !this.state.notify_marketing_campaigns })}
                                                    checked={this.state.notify_marketing_campaigns}
                                                />
                                                Campañas de marketing
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body d-flex justify-content-end">
                                    <button
                                        className="btn btn-primary"
                                        disabled={this.state.loading}
                                    >
                                        {this.state.loading && (
                                            <span className="spinner-border spinner-border-sm mr-2"></span>
                                        )}
                                        <span>Guardar</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {this.state.message && (
                        <div className="form-group">
                            <div className="alert alert-danger" role="alert">
                                {this.state.message}
                            </div>
                        </div>
                    )}
                    <CheckButton
                        style={{ display: "none" }}
                        ref={c => {
                            this.checkBtn = c;
                        }}
                    />
                    </Form>
                    </TabPanel>

                    <TabPanel>
                        <WhatsappProviderSettings />
                    </TabPanel>
                </Tabs>
                </div>
            </Fragment>
        )
    }
}

export default VerSettings
